<div class="host"
     [ngClass]="{ 'bg_red': spentEstimate < 0, 'header_indicator': isHeaderIndicator}"
>
  <span *ngIf="!isHeaderIndicator">Capacity: {{taskEstimate | toHms: 'short'}}
    /{{column.backlogCapacity | toHms: 'short'}}</span>
  <span *ngIf="!isHeaderIndicator">({{spentEstimate | abs | toHms: 'short'}} {{spentEstimate >= 0 ? 'left' : 'overwhelmed'}})</span>
</div>
